/* Пуши в приложении из стора (iOS; Android — когда будет Firebase). В браузере (PWA) ничего не делает.
   После входа и мастера — системный запрос разрешения (один раз), токен устройства — на сервер
   (clientApp.pushToken), нажатие на пуш — экран из data.go. Что и когда шлёт сервер — api/src/services/push.ts. */
import { api } from '@tg/app-core';
import { PushNotifications } from '@capacitor/push-notifications';
import { lsGet, lsSet } from './storage';

type W = Window & { Capacitor?: { isNativePlatform?: () => boolean; getPlatform?: () => string } };
const platform = () => {
  const c = (window as W).Capacitor;
  return c?.isNativePlatform?.() ? c.getPlatform?.() || '' : '';
};

let wired = false;
let go: (path: string) => void = () => {};
let onNew: () => void = () => {};

/** Подключить пуши: open — открыть экран по нажатию, fresh — пуш пришёл при открытом приложении (обновить ленту) */
export async function initPush(open: (path: string) => void, fresh: () => void) {
  go = open;
  onNew = fresh;
  if (platform() !== 'ios') return;
  try {
    if (!wired) {
      wired = true;
      await PushNotifications.addListener('registration', (t) => {
        lsSet('pushToken', t.value);
        api.clientApp.pushToken.mutate({ token: t.value, platform: 'ios' }).catch(() => {});
      });
      await PushNotifications.addListener('pushNotificationActionPerformed', (a) => {
        const p = (a.notification.data as { go?: string } | undefined)?.go;
        if (p) go(p);
      });
      await PushNotifications.addListener('pushNotificationReceived', () => onNew());
    }
    let st = await PushNotifications.checkPermissions();
    if (st.receive === 'prompt' || st.receive === 'prompt-with-rationale') st = await PushNotifications.requestPermissions();
    /* Разрешено — регистрируемся при каждом запуске: токен мог смениться */
    if (st.receive === 'granted') await PushNotifications.register();
  } catch {
    /* нет плагина в старой сборке — без пушей */
  }
}

/** Выход: устройство больше не получает пуши этого клиента (до выхода — пока сессия жива) */
export async function forgetPush() {
  const t = lsGet<string | undefined>('pushToken', undefined);
  if (!t) return;
  lsSet('pushToken', undefined);
  await api.clientApp.pushForget.mutate({ token: t }).catch(() => {});
}
